module.exports = __webpack_public_path__ + "img/Costco.4346b656.png";